<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="verify(single_object.id, global_index)">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return {
            form_format:    FormResources.form_format,
        }
    },
    
    methods: {

        verify(id, global_index) {
            let flag_verify = true;

            if(!this.single_object.daily_shift_1 && !this.single_object.daily_shift_2 && !this.single_object. daily_shift_3) {
                this.notyf.error('you must select at least one option of Daily');
                flag_verify = false;
            }
            
            if(!this.single_object.policing_shift_1 && !this.single_object.policing_shift_2 && !this.single_object.policing_shift_3) {
                this.notyf.error('you must select at least one option of Policing');
            }

            if(!this.single_object.project_shift_1 && !this.single_object.project_shift_2 && !this.single_object.project_shift_3) {
                this.notyf.error('you must select at least one option of Project');
                flag_verify = false;
            }

            if(flag_verify) {
                this.form_submit_update(id,global_index);
            } else {
                return;
            }
        },

    },

    mounted(){

    },
    watch: {

        'single_object.frequency'(val)
        {
            if(val < 1 || val > 7)
            {
                this.single_object.frequency = 1
            }
        },

        async 'single_object.building_id'(val) {
            if(val) {
                let http_request = {
                    id:             val,
                    level_request:  true,
                }
                const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);
                if(response.status) {
                    this.array_options.level_id = response.data.levels;
                } else {
                    this.error_handling(response)
                }
            }
        },
    }
    
}
</script>